<template>
  <div>
    <div class="OHowPeopleUseLifferyFriends">
      <div class="person pl-2">
        <div class="face">
          <img src="@/assets/landing-pages/forPeople/2023/face-the-friends.svg" alt="Liffery friends"/>
        </div>

        <div class="description content">
          <h2>
            {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferyFriends.title') }}
          </h2>
          <p>
            {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferyFriends.text') }}
          </p>
          <p>
            <router-link
                v-if="getIsAuthenticated"
                :to="{name: routeNames.ROUTE_DASHBOARD}"
            >
              <b-button>
                {{ $t('page.whatIsLiffery.new2023.loggedIn') }}
              </b-button>
            </router-link>
            <b-button
                v-else
                @click="loginPrompt">
              {{ $tc('page.whatIsLiffery.new2023.tryItOut') }}
            </b-button>
          </p>

        </div>
      </div>

      <div class="map">
        <o-channel-items-map
            v-if="loadMap"
            channel="john.carmichael1@lisbon-and-silver-coast-restaurants"
            :map-options="{
              zoomControl: true,
              mapTypeControl: false,
              fullscreenControl: true,
              gestureHandling: 'cooperative',
              scrollwheel: false,
            }"
            :hide-fetch-more-buttom="true"
            :map-styles="mapStyles"
            :scroll-into-view-onload="false"
            :add-map-coords-to-url="false"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.OHowPeopleUseLifferyFriends {
  background-color: #a2c0f4;
  display: flex;
  justify-content: center;
  align-items: center;

  .person {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4rem;
    min-width: 50%;
    width: 50%;

    .description {
      width: 300px;
    }
  }

  .map {
    min-width: 50%;
    width: 50%;
  }

  @media screen and (max-width: $desktop) {
    .person {
      flex-direction: column;
      align-items: flex-end;
      gap: 2rem;

      .face {
        margin-right: 7rem;
      }
    }
  }

  @media screen and (max-width: $tablet) {
    flex-direction: column;
    padding-top: 8rem;

    .person {
      flex-direction: column;
      align-items: center;
      gap: 2rem;
      padding-bottom: 2rem;

      .face {
        margin-right: unset;
      }

      .description {
        width: 80vw;
        text-align: center;
      }
    }

    .map {
      min-width: 100%;
      width: 100%;

      ::v-deep .OChannelItemsMap .map-container {
        height: 65vh;
      }
    }
  }
}
</style>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AuthenticationStore } from '@/store';
import OChannelItemsMap from '@/components/organisms/OChannelItemsMap.vue';
import { RouteNames } from '@/router/RouteNames';
import { EnumRegisteredFromAction } from '@/store/modules/interfaces/AuthenticationModule';

@Component({
  components: { OChannelItemsMap }
})
export default class OHowPeopleUseLifferyFriends extends Vue {
  @Prop({ default: false })
  loadMap!: boolean;

  routeNames = RouteNames;

  get getIsAuthenticated () {
    return AuthenticationStore.getAuthenticated;
  }

  windowWidth: number = 0;
  mapStyles = [
    {
      'featureType': 'water',
      'elementType': 'geometry.fill',
      'stylers': [
        {
          'color': '#a2c0f4'
        }
      ]
    },
  ];

  created () {
    this.windowWidth = window.innerWidth;
  }

  loginPrompt () {
    AuthenticationStore.TOGGLE_PROMPT_SIGNUP({
      state: true,
      metaData: {
        registeredFromAction: EnumRegisteredFromAction.ctaMap
      }
    });
  }
}
</script>
